export const FETCH_ASSETSETTINGS_BEGIN = "FETCH_ASSETSETTINGS_BEGIN";
export const FETCH_ASSETSETTINGS_SUCCESS = "FETCH_ASSETSETTINGS_SUCCESS";
export const FETCH_ASSETSETTINGS_FAILURE = "FETCH_ASSETSETTINGS_FAILURE";


//BenchMark Entities Constants
export const FETCH_BENCHMARKENTITIES_BEGIN = "FETCH_BENCHMARKENTITIES_BEGIN";
export const FETCH_BENCHMARKENTITIES_SUCCESS = "FETCH_BENCHMARKENTITIES_SUCCESS";
export const FETCH_BENCHMARKENTITIES_FAILURE = "FETCH_BENCHMARKENTITIES_FAILURE";
